module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.f121e63.woff";